export const AlertLevel = {
	Danger: 1,
	Warning: 2,
	Info: 3,
	Success: 4,
	None: 5
};

export const AlertLevelNames = {
	[AlertLevel.Danger]: 'danger',
	[AlertLevel.Warning]: 'warning',
	[AlertLevel.Info]: 'info',
	[AlertLevel.Success]: 'success',
	[AlertLevel.None]: ''
};

export const AlertTypes = {
	RESULT_MISMATCH: 1,
	NOT_FINALISED: 2,
	SELECTION_LIABILITY_EXCEEDED: 3,
	MULTI_SELECTIONS_LIABILITY_EXCEEDED: 4,
	SGM_SELECTION_LIABILITY_EXCEEDED: 5,
	SGM_MULTI_SELECTIONS_LIABILITY_EXCEEDED: 6
};

export const AlertTypesNames = {
	[AlertTypes.RESULT_MISMATCH]: 'Result Mismatch',
	[AlertTypes.NOT_FINALISED]: 'Not Finalised',
	[AlertTypes.SELECTION_LIABILITY_EXCEEDED]: 'Selection Liability Exceeded',
	[AlertTypes.MULTI_SELECTIONS_LIABILITY_EXCEEDED]: 'Multi Selections Liability Exceeded',
	[AlertTypes.SGM_SELECTION_LIABILITY_EXCEEDED]: 'SGM Selection Liability Exceeded',
	[AlertTypes.SGM_MULTI_SELECTIONS_LIABILITY_EXCEEDED]: 'SGM Multi Selections Liability Exceeded'
};
